import { APIGet } from "api/protocols";
import { CancelToken } from "axios";
import { ISalesChannel } from "redux/reducers/models/product";

const apiVersion = "2024-04";
const adminType = "client-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/facility/sales-channel";

//GET Sales Channels
//Retrieve a list of sales channels
export async function GetAllSalesChannels(
  params?: { id: string | number },
  useGlobalLoader?: boolean,
  token?: CancelToken,
) {
  return await APIGet<ISalesChannel | ISalesChannel[]>(baseUrl, params, useGlobalLoader, token);
}
